<template>
    <button type="button"
        size="sm" :class="currentValue.classButton"
        @click="onClickFunction()"
        :title="currentValue.hoverLabel">
            <i :class="currentValue.icon" :style="{ color: currentValue.color }"></i>
    </button>&nbsp;
</template>

<script>
import $ from 'jquery'
import config from '@/config/prod.env'
import objectDefaultValue from '@/config/object.env'
import i18n from '@/helper/i18n'
export default {
    name: "TheButtonInDropdown",
    props: {
        modelValue: {
            type: [String],
            default: null,
        },
        onClick: {
            type: Function,
            required: true
        },
        submitArgs: {
            type: Array,
            default: () => [], // Default to an empty array if no arguments are passed
        },

        useChildMethos: {
            type: Boolean,
            default: false,
        },

        mapParams: {
            type: Object, // Dữ liệu params dạng object
            required: false, // Không bắt buộc
            default: () => ({}),
        },
    },
    data() {
        return {
            localValue: this.modelValue,
            currentValue: {
                typeButton: ``,
                hoverLabel: ``,
                icon: ``,
                label: ``,
                color: ``,
                classButton: ``,
            },
            listAvailabelButton: [
                {
                    typeButton: objectDefaultValue.TABLEBUTTON.VIEWDETAILMAP,
                    hoverLabel: 'Xem vị trí',
                    icon: `fas fa-map-marked-alt`,
                    label: 'Xem vị trí',
                    color: `#28a745`,
                    classButton: 'btn btn-outline-primary btn-xs',
                },
                {
                    typeButton: objectDefaultValue.TABLEBUTTON.VIEWDETAIL,
                    hoverLabel: this.$t('labels.detail'),
                    icon: `fas fa-eye text-secondary`,
                    label: this.$t('buttons.delete'),
                    color: `#ffc107`,
                    classButton: 'btn btn-outline-primary btn-xs',
                },
                {
                    typeButton: objectDefaultValue.TABLEBUTTON.EDIT,
                    hoverLabel: this.$t('labels.update'),
                    icon: `fas fa-pencil-alt`,
                    label: this.$t('labels.update'),
                    color: `#007bff`,
                    classButton: 'btn btn-outline-primary btn-xs',
                },
                {
                    typeButton: objectDefaultValue.TABLEBUTTON.DELETE,
                    hoverLabel: this.$t('buttons.deleteFake'),
                    icon: `fas fa-trash-alt`,
                    label: this.$t('buttons.deleteFake'),
                    color: `#ff851b`,
                    classButton: 'btn btn-outline-primary btn-xs',
                },
                {
                    typeButton: objectDefaultValue.TABLEBUTTON.RESTORE,
                    hoverLabel: this.$t('buttons.restore'),
                    icon: `fas fa-undo`,
                    label: this.$t('buttons.restore'),
                    color: `#6610f2`,
                    classButton: 'btn btn-outline-primary btn-xs',
                },

                {
                    typeButton: objectDefaultValue.TABLEBUTTON.DELETE_REAL,
                    hoverLabel: this.$t('labels.deleteReal'),
                    icon: `fas fa-trash-alt`,
                    label: this.$t('labels.deleteReal'),
                    color: `#dc3545`,
                    classButton: 'btn btn-outline-primary btn-xs',
                },
            ],
            isTrueValue: true,
        };
    },
    watch: {
        modelValue: {
            immediate: true,
            handler(newValue) {
                // Tìm trong listAvailabelButton
                const foundButton = this.listAvailabelButton.find(button => button.typeButton === newValue);
                if (foundButton) {
                    this.currentValue = { ...foundButton };
                } else {
                    console.warn(`No button found for modelValue: ${newValue}`);
                }
            }
        }
    },
    methods: {
        onClickFunction() {
            if (typeof this.onClick === 'function') {
                if(this.useChildMethos === true && this.currentValue.typeButton === objectDefaultValue.TABLEBUTTON.VIEWDETAILMAP) {
                    this.onMapClick();
                }
                else
                this.onClick(...this.submitArgs);
            } else {
                console.error('onClick is not a function');
            }
        },

        async onMapClick() {
            try {
                const res = await this.onClick({ params: this.mapParams }); // Gọi hàm được truyền từ Vuex action
                if (res) {
                    let tableID = res[0].tableId ? res[0].tableId : null
                    let loaiDiadiemId = (res[0].loaiDiadiemId != undefined) ? res[0].loaiDiadiemId.toString() : null
                    let phanloaiDiadiemId = (res[0].phanloaiDiadiemId != undefined) ? res[0].phanloaiDiadiemId.toString() : null
                    if (tableID || loaiDiadiemId || phanloaiDiadiemId) {
                        let link = config.QUYHOACH_PAGE + "AppCongDan/MapTienIch?"
                        link = tableID ? (link + "tableId=" + tableID) : link
                        link = loaiDiadiemId ? link + "&loaiDiadiemId=" + loaiDiadiemId : link
                        link = phanloaiDiadiemId ? link + "&phanloaiDiadiemId=" + phanloaiDiadiemId : link
                        link = this.submitArgs[0] ? link + "&detailId=" + this.submitArgs[0] : link
                        window.open(link, "_blank");
                    }
                }
                else {
                    this.$store.dispatch("alert/error", "Lấy thông tin bản đồ thất bại!", { root: true });
                }
            } catch (error) {
                console.error("Lỗi khi gọi Vuex action:", error);

            }
        },
    },
    mounted() {
        // Gán giá trị ban đầu từ modelValue nếu có
        if (this.modelValue) {
            const foundButton = this.listAvailabelButton.find(button => button.typeButton === this.modelValue);
            if (foundButton) {
                this.currentValue = { ...foundButton };
            }
        }
    },
};
</script>

<style></style>